The response from the `deleteUploadedCandidate` mutation.
